import React from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

export default class ComponentToPrint extends React.Component {
  render() {
    const data = this.props.qRTagsDetailsList;

    return (
      <div>
        <style>
          {`
          @media print {
            @page {
              margin: 0 auto;
              margin-top: 0;
              margin-bottom: 0;
              margin-left: 20mm; 
              margin-right: 20mm;
            }
            body {
              margin: 0;
            }
          }
          `}
        </style>
        <table className="display dataTable no-footer">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 4fr)",
              gridGap: "10px",
            }}
          >
            {data.map((d, i) => {
              return (
                <div
                  key={i}
                  style={{
                    textAlign: "center",
                    pageBreakInside: "avoid",
                    border: "1px solid #000",
                    padding: "5px",
                  }}
                >
                  <QRCode value={d.tagNo} size={150} />
                  <Barcode width={2} height={50} value={d.tagNo} />
                </div>
              );
            })}
          </div>
        </table>
      </div>
    );
  }
}
